module.exports = __webpack_public_path__ + "media/images/prediction/special/nagai_hiratsuka/bg_racemsg-6b69c4b801ddc3991f8f51f3bb233f72.jpg";